module.exports = __webpack_public_path__ + "assets/917ed713b0734df0ed6975407552c910.mp4";